import React, { Component } from 'react';

class HowToUse extends Component {

  constructor(props) {
    super(props);
  }


  render() {

    return (
      <div>
        <strong>How do I ... ?</strong><br/>
        <ul>
          <li><u>Add a Sentence</u> Hover your mouse over the white space just before or after an existing sentence. A plus sign will appear; click it. To start a new paragraph, hover over the white space where that new paragraph would begin. A plus sign will appear; click it.</li>
          <li><u>Edit a Sentence</u> Click on a sentence to propose an alternative wording. From this menu you can also cast your vote for the wording of your preference if there are others. Majority rules. Ties are broken by the most recent vote.</li>
          <li><u>Delete a Sentence</u> Click on the sentence you want to delete. Propose a blank alternative.</li>
          <li><u>Vote for an Edit</u> The highlight color of a sentence tells you about the edits proposed for that sentence. A gray highlight means they are edits, but none have any votes. A yellow/orange highlight means there is contention over this wording: there are edits which have minority votes you will see once you click on the sentence. The more contentious the alternatives, the darker the highlight color. </li>
          <li><u>Invite Co-Authors</u> Send them the sharing link on the left-hand side below your document. </li>
          <li><u>Stylize Text</u> You can use basic html text styling tags such as &lt;b&gt;word&lt;/b&gt; (bold), &lt;i&gt;word&lt;/i&gt; (italic), & &lt;u&gt;word&lt;/u&gt; (underline) in your sentences to give emphasis to certain words. </li>
        </ul>
      </div>
      )
  }
}
export default HowToUse;
